import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { ERequestType } from "../../Enum/ERequestType"
import { orderMemory } from "../../Objects/Memory/Memory"
import { OrderEntity } from "../../Objects/Order/OrderEntity"
import { GetRequest, PostRequest } from "../../services/ApiClientService"

export const useServicePointSelfServiceOrders = () => {
  const { t } = useTranslation()

  const { setError } = useError()

  const handleReloadServicePointSelfServiceOrders = async (storeSlug?: string) => {
    if (!storeSlug) {
      return false
    }

    try {
      const response = await GetRequest<OrderEntity[]>(
        API_ROUTES.ORDER.GET_SERVICE_POINT_SELF_SERVICE_OPEN(storeSlug),
        ERequestType.ServicePointSelfService,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      orderMemory.setList(response.data?.map((order) => new OrderEntity(order)) ?? [])
      return true
    } catch (error) {
      setError(
        t("general:label_title_erro"),
        error instanceof Error ? error.message : t("general:label_unknown_error_description"),
      )
      return false
    }
  }

  const handleCancelServicePointSelfServiceOrder = async (storeSlug: string | undefined, order: OrderEntity) => {
    if (!storeSlug) {
      return false
    }

    try {
      const response = await PostRequest(
        API_ROUTES.ORDER.CANCEL_SERVICE_POINT_SELF_SERVICE(storeSlug, order.id),
        { concurrencyToken: order.concurrencyToken },
        ERequestType.ServicePointSelfService,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      await handleReloadServicePointSelfServiceOrders(storeSlug)
      return true
    } catch (error) {
      setError(
        t("general:label_title_erro"),
        error instanceof Error ? error.message : t("general:label_unknown_error_description"),
      )
      return false
    }
  }

  return {
    handleCancelServicePointSelfServiceOrder,
    handleReloadServicePointSelfServiceOrders,
  }
}
